import { rgba } from 'polished';
import { ColorScheme } from 'shared/assets/styles/theme/color-schemes';
import { css } from 'styled-components';

export const focusOutline = css`
  outline: 3px solid
    ${({ theme }) =>
      theme.colorScheme === ColorScheme.Dark
        ? rgba(theme.palette.primary.dark, 0.6)
        : rgba(theme.palette.primary.main, 0.4)};
  outline-offset: 0;
`;
